module.exports = __webpack_public_path__ + "media/images/icon-user-41c21a79e49ea4103ddcbdc03ad97bb6.png";